import {capitalize} from 'underscore.string';
import PropTypes from 'prop-types';
import React from 'react';
import {compose, setDisplayName, withState} from 'recompose';

import OndemandBase from 'ondemand/components/OndemandBase';
import LabeledActionButton from 'ondemand/components/LabeledActionButton';
import HourGlassHighIcon from 'common/components/icons/HourGlassHighIcon';
import HourGlassMediumIcon from 'common/components/icons/HourGlassMediumIcon';
import HourGlassLowIcon from 'common/components/icons/HourGlassLowIcon';

const colors = {
  high: '#CB0026',
  medium: '#F1AA12',
  low: '#6ABB26',
  unknown: 'gray',
};

const icons = {
  high: <HourGlassHighIcon style={{width: 14}} />,
  medium: <HourGlassMediumIcon style={{width: 14}} />,
  low: <HourGlassLowIcon style={{width: 14}} />,
  unknown: <HourGlassHighIcon style={{width: 14}} />,
};

const enhance = compose(setDisplayName('ServiceLoadControl'), withState('open', 'setOpen', false));

const ServiceLoadControl = enhance(({load, thresholds, open, setOpen}) => {
  const labels = {
    high: `Wait time is >${thresholds.high} minutes`,
    medium: `Wait time is ${thresholds.medium}-${thresholds.high} minutes`,
    low: `Wait time is <${thresholds.medium} minutes`,
    unknown: 'Unable to estimate wait time',
  };
  const label = <span><b>{capitalize(load)}:</b> {labels[load]}</span>;
  return (
    <div data-id="service-load-control" style={{pointerEvents: 'none'}}>
      <OndemandBase>
        <LabeledActionButton
          buttonBackgroundColor={colors[load]}
          direction="right"
          label={<div data-id="service-load-message" style={{fontSize: 14}}>{label}</div>}
          onClick={() => setOpen(!open)}
          open={open}
          mini
        >
          {icons[load]}
        </LabeledActionButton>
      </OndemandBase>
    </div>
  );
});

ServiceLoadControl.propTypes = {
  load: PropTypes.oneOf(['high', 'medium', 'low', 'unknown']).isRequired,
  thresholds: PropTypes.shape({
    medium: PropTypes.number.isRequired,
    high: PropTypes.number.isRequired,
  }).isRequired,
};

export default ServiceLoadControl;



// WEBPACK FOOTER //
// ./src/ondemand/components/ServiceLoadControl.js